<template>
  <div class="box">
    <!-- 箱子列表 -->
    <div v-for="(item, index) in boxList" :key="index" class="boxList">
      <div class="box-head">
        <div class="checkbox">
          <!-- 全选 -->
          <el-checkbox v-model="item.checked" @change="handleCheckedChange(index)">
            {{ $t("message.allChecked") }}
          </el-checkbox>
        </div>
        <!-- 装箱状态： -->
        <div class="item">
          {{ $t("message.encasementStatus") }} : <span>{{ item.status_name }}</span>
        </div>
        <!-- 合计重量 -->
        <div class="item">
          {{ $t("message.totalWeight") }} : <span>{{ item.total_weight }}KG</span>
        </div>
        <!-- 合计体积 -->
        <div class="item">
          {{ $t("message.totalVolume") }} : <span>{{ item.total_volume }}m³</span>
        </div>
      </div>
      <!-- 箱子列表 -->
      <div class="box-list">
        <div v-for="(box, boxIndex) in item.list" :key="boxIndex" class="box-item">
          <div class="checkbox">
            <el-checkbox v-model="box.checked" @change="checkedChange(index)"></el-checkbox>
          </div>
          <div class="box-detail" @click="showMovingGoodsBox(item.status_name, box.id)">
            <div class="row">
              <div class="key">NO：</div>
              <div class="value" style="color: #B4272D;font-weight: bold;">{{ box.box_no }}</div>
            </div>
            <!-- 实重 -->
            <div class="row">
              <div class="key">{{ $t("message.actualWeightS") }}：</div>
              <div class="value">{{ box.weight }}KG</div>
            </div>
            <!-- 尺寸 -->
            <div class="row">
              <div class="key">{{ $t("message.size") }}：</div>
              <div class="value">{{ box.attr }}cm</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动商品箱子 -->
    <movingGoodsBox ref="movingGoodsBox" :move_sn="move_sn" />
  </div>
</template>
<script>
import movingGoodsBox from './movingGoodsBox.vue'
import { mapState } from 'vuex'
export default {
  components: {
    movingGoodsBox,
  },
  computed: {
    ...mapState({
      boxList: state => state.transferOrderDetail.boxList
    }),
  },
  data() {
    return {
      move_sn: this.$route.query.move_sn,

    }
  },
  mounted() {
    this.$store.dispatch('transferOrdeBoxList', {
      move_sn: this.move_sn,
    })
  },
  methods: {
    // 库存转移-全选/取消全选
    handleCheckedChange(index) {
      this.boxList[index].list.forEach(box => {
        box.checked = this.boxList[index].checked
      })
      this.$forceUpdate()
    },
    // 库存转移-选中/取消选中
    checkedChange(index) {
      this.boxList[index].checked = this.boxList[index].list.every(box => box.checked)
      this.$forceUpdate()
    },
    // 显示移动商品箱子
    showMovingGoodsBox(status_name, id) {
      this.$refs.movingGoodsBox.box_id = id
      this.$refs.movingGoodsBox.boxStatus = status_name
      this.$refs.movingGoodsBox.getBoxDetail()
      this.$refs.movingGoodsBox.dialogVisible = true
      if (status_name == '装箱中') {
        this.$refs.movingGoodsBox.getBoxList()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.box {
  margin-bottom: 24px;
  padding: 24px;
  background: #f8f8f8;

  .box-head {
    width: 100%;
    display: flex;
    padding: 18px;
    border-radius: 4px;
    background: #EDEFF4;

    .checkbox {
      margin-right: 60px;
    }

    .item {
      margin-left: 30px;

      span {
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
    }
  }

  .boxList {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .box-list {

    display: flex;
    flex-wrap: wrap;
    padding: 0 8px;

    .box-item {
      display: flex;
      align-items: center;
      background: #FFFFFF;
      padding: 12px;
      border: 1px solid #DCDFE6;
      margin: 12px 12px 0 0;
      border-radius: 4px;

      .checkbox {
        width: 20px;
        height: 100%;
        margin-top: 10px;
      }

      .box-detail {
        margin-left: 12px;
        cursor: pointer;

        .row {
          display: flex;
          margin-bottom: 10px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }


    }
  }
}
</style>